// extracted by mini-css-extract-plugin
export default {"servicesSubcategoryList":"AP0pSa20qU3TQ_DGJa6w","open":"n3GhaNdjvTAIbVc0Iosg"};